import React from 'react';
import { Inbox } from 'lucide-react';
import { cn } from './cn';
import { IconShape } from './IconShape';

/**
 * EmptyState — trạng thái rỗng có icon + tiêu đề + mô tả + (tuỳ chọn) hành động.
 */
export function EmptyState({ icon = Inbox, title = 'Chưa có dữ liệu', description, action, className, ...props }) {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center py-12 px-6', className)} {...props}>
      <IconShape icon={icon} variant="gray" size="lg" className="mb-4" />
      <p className="text-base font-medium text-heading">{title}</p>
      {description ? <p className="text-sm text-muted mt-1 max-w-sm">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}

export default EmptyState;
